/** @format */

import React, {useContext, useReducer, useEffect, useCallback} from 'react';
import {useRouter} from 'next/router';

import {pageUrl, requestData} from '@utils/product';
import {reducer} from '@reducers/product/list';
import {api} from '@utils/api';

const RetailerContext = React.createContext();
export const RetailerProvider = ({children, props}) => {
	const [state, dispatch] = useReducer(reducer, {
		filters: [],
		retailers: [],
		loading: true,
	});

	const router = useRouter();

	const loadStores = useCallback(async () => {
		const {retailers} = await api({
			url: '/product/retailers',
			method: 'POST',
			data: {
				...requestData({
					filters: {
						brand: props.filters.brand,
						category: props.filters.category,
						name: props.filters.name,
						// eslint-disable-next-line camelcase
						price_from: props.filters.price_from,
						// eslint-disable-next-line camelcase
						price_to: props.filters.price_to,
						shipping: props.filters.shipping,
					},
					category: props.category,
					brand: props.brand,
				}).filter,
			},
		});

		let filters = [];
		if (props.filters.retailer) {
			let selected = props.filters.retailer.split('|');
			filters = retailers
				.filter(r => selected.indexOf(r._id.toString()) !== -1)
				.map(r => ({
					_id: r._id,
					label: r.shop_name,
					type: 'retailer',
				}));
		}

		dispatch({
			type: 'SET_DATA',
			data: {
				filters,
				retailers,
				loading: false,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		props.filters.brand,
		props.filters.category,
		props.category,
		props.brand,
		props.filters.retailer,
		props.filters.price_from,
		props.filters.price_to,
		props.filters.name,
		props.filters.options,
		props.filters.shipping,
	]);

	useEffect(() => {
		if (!props.isAuction) loadStores();
	}, [loadStores, props.isAuction]);

	const updateFilter = (filters, push = false) => {
		dispatch({
			type: 'SET_DATA',
			data: {
				filters,
			},
		});

		if (push) {
			let retailer = null;
			for (let i = 0; i < filters.length; i++) {
				const filter = filters[i];
				if (retailer) {
					retailer += `|${filter._id}`;
				} else {
					retailer = filter._id;
				}
			}

			let query = props.filters;
			if (retailer) {
				query.retailer = retailer;
			} else {
				delete query.retailer;
			}

			delete query.page;
			router.push({
				pathname: pageUrl(props),
				query,
			});
		}
	};

	return (
		<RetailerContext.Provider
			value={{
				retailers: state.retailers,
				filters: state.filters,
				loading: state.loading,
				updateFilter,
			}}
		>
			{children}
		</RetailerContext.Provider>
	);
};

export function useRetailer() {
	const context = useContext(RetailerContext);
	if (context === undefined) {
		throw new Error('useRetailer must be used within a RetailerProvider');
	}
	return context;
}
